import { WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES } from "@apps/wishlist/constants/constants";
import { ShareWishlistsResultEntity } from "@apps/wishlist/entities/ShareWishlistsResultEntity";
import { WishlistWithItemsEntity } from "@apps/wishlist/entities/WishlistWithItemsEntity";
import { ShareWishlistsResultSchema } from "@apps/wishlist/schemas/ShareWishlistsResultSchema";
import { wishlistAuthApiClientToken } from "@apps/wishlist/tokens";
import { JsonMimeType } from "@lib/ApiClient";
import AuthApiClient from "@lib/ApiClient/AuthApiClient";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, injectable } from "tsyringe";

import { GetWishlistsResponseSchema } from "./WishlistsApiService/responses/GetWishlistsResponseSchema";

@injectable()
export class ShareWishlistsApiService {
    public constructor(
        @inject(wishlistAuthApiClientToken)
        private readonly apiClient: AuthApiClient
    ) {}

    shareWishlists(
        channelName: WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES,
        wishlistIds: number[]
    ): Observable<ShareWishlistsResultEntity> {
        let url = "/shareWishlists";
        if (channelName !== WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.copyShareLink) {
            url += `/${channelName}`;
        }

        return this.apiClient
            .post({
                url,
                body: JSON.stringify({ wishlistIds }),
                contentType: JsonMimeType,
            })
            .pipe(
                map((response) => {
                    const result = create(
                        response.body,
                        ShareWishlistsResultSchema
                    );
                    return result;
                })
            );
    }

    getSharedWishlists(
        shareToken: string
    ): Observable<WishlistWithItemsEntity[]> {
        return this.apiClient
            .post({
                url: "/getSharedWishlists",
                body: JSON.stringify({
                    shareToken,
                }),
                contentType: JsonMimeType,
            })
            .pipe(
                map((response) => {
                    const result = create(
                        response.body,
                        GetWishlistsResponseSchema
                    );

                    return result.wishlistsWithItems;
                })
            );
    }
}
